"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const Icon_1 = tslib_1.__importDefault(require("../../../../ui-lib/Buttons/Icon"));
const Icons_1 = tslib_1.__importDefault(require("../../../../ui-lib/Icons"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularPauseBroadcastButton = (0, mobx_react_lite_1.observer)(({ icon: ProvidedIcon, onClick, screenReaderText, active, classes = {
    root: {},
    icon: {},
}, label = "Pause Broadcast Toggle Button", ...props }) => {
    const componentName = "<PauseBroadcastButton/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const encoderCtx = (0, react_1.useContext)(context_1.EncoderUiContext);
    const callCtx = (0, react_1.useContext)(context_1.CallContext);
    /**
     * Grab the videoClient supplied from the encoder.
     */
    const videoClient = (0, react_1.useContext)(context_1.VideoClientContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)((encoderCtx === null || encoderCtx === void 0 ? void 0 : encoderCtx.mediaStreamController) != null && videoClient != null && callCtx != null, componentName);
    const activeState = callCtx.broadcastPaused;
    async function handlePauseBroadcast() {
        if (callCtx != null && (encoderCtx === null || encoderCtx === void 0 ? void 0 : encoderCtx.mediaStreamController)) {
            await callCtx.togglePauseBroadcast(encoderCtx.mediaStreamController);
        }
    }
    /**
     * handleClick function wrapped in global Error handler (to trigger ErrorBoundary).
     * */
    const handleClick = onClick !== null && onClick !== void 0 ? onClick : (0, ErrorBoundary_1.useUIEventError)(handlePauseBroadcast, componentName);
    const defaultIcon = activeState ? (react_1.default.createElement(Icons_1.default, { iconName: "play", classes: classes === null || classes === void 0 ? void 0 : classes.icon })) : (react_1.default.createElement(Icons_1.default, { iconName: "pause", classes: classes === null || classes === void 0 ? void 0 : classes.icon }));
    const icon = ProvidedIcon !== null && ProvidedIcon !== void 0 ? ProvidedIcon : defaultIcon;
    if (callCtx.activePlaceholder == null) {
        return null;
    }
    return (react_1.default.createElement(Icon_1.default, { active: activeState, classes: classes, inactiveClass: null, "data-selenium": "broadcast-stream-button", icon: icon, onClick: handleClick, disabled: !callCtx.isBroadcasting, label: label, ...props }, screenReaderText !== null && screenReaderText !== void 0 ? screenReaderText : `Click to ${activeState ? "Resume" : "Pause"} Broadcast`));
});
/**
 *
 * @visibleName Pause Broadcast Button
 */
function PauseBroadcastButtonWithErrorBoundary({ icon: ProvidedIcon, label = "Pause Broadcast Toggle Button", screenReaderText, classes, ...props }) {
    const icon = react_1.default.createElement(Icons_1.default, { iconName: "pause", classes: classes === null || classes === void 0 ? void 0 : classes.icon });
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(Icon_1.default, { "data-selenium": "pause-broadcast-button", disabled: true, classes: classes, icon: ProvidedIcon !== null && ProvidedIcon !== void 0 ? ProvidedIcon : icon, label: label, onClick: undefined, active: false, ...props }, screenReaderText !== null && screenReaderText !== void 0 ? screenReaderText : "Click to pauseBroadcast")) },
        react_1.default.createElement(ModularPauseBroadcastButton, { icon: ProvidedIcon, classes: classes, label: label, screenReaderText: screenReaderText, ...props })));
}
exports.default = PauseBroadcastButtonWithErrorBoundary;
//# sourceMappingURL=PauseBroadcast.js.map